import { theme } from "twin.macro";
import Paragraph from "@atoms/Paragraph";
import IconClose from "@iconsV2/Edit/close.svg?react";
import { dismissToast, useToasts } from "@/utils/toast";
import { StyledIconBox, StyledIconStore, StyledProgress, StyledToast, StyledToaster } from "./styles";

const Toaster = () => {
  const toasts = useToasts();

  if (toasts.length === 0) return null;

  return (
    <StyledToaster aria-live="polite">
      {toasts.map((toast) => (
        <StyledToast key={toast.id} role="status">
          <StyledIconBox>
            <StyledIconStore />
          </StyledIconBox>

          <div tw="flex-1 grid gap-xs">
            <Paragraph sizeVariant="md" size="small" fontWeight={600} color={theme`colors.neutral.5`}>
              {toast.title}
            </Paragraph>
            {toast.description && (
              <Paragraph sizeVariant="sm" size="large" color={theme`colors.neutral.40`}>
                {toast.description}
              </Paragraph>
            )}
          </div>

          <button type="button" aria-label="Cerrar" onClick={() => dismissToast(toast.id)}>
            <IconClose tw="h-5 w-5 fill-neutral-20" />
          </button>

          <StyledProgress $duration={toast.duration} onAnimationEnd={() => dismissToast(toast.id)} />
        </StyledToast>
      ))}
    </StyledToaster>
  );
};

export default Toaster;
